import { Button, Paper } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { GreyButton } from "views/tasks/styles";
import { snack } from "./toast";
import { useSideNavOffset } from "context/SideNavOffset";

interface Props {
  data: any;
  state: any;
  onUpdate: () => Promise<any>;
  onCancel: () => void;
  left?: string;
  align?: "left" | "right" | "center";
  isLoading: boolean;
}

function BottomBar(props: Props) {
  const { data, state, onUpdate, onCancel, align, isLoading } = props;
  const sideNavOffset = useSideNavOffset();
  const left = props.left || sideNavOffset;
  const [isStateChanged, setIsStateChanged] = useState(false);

  useEffect(() => {
    setIsStateChanged(JSON.stringify(data) !== JSON.stringify(state));
  }, [state, data]);

  const handleUpdate = async () => {
    try {
      await onUpdate();
      setIsStateChanged(false);
    } catch (e) { }
  };

  const position =
    align === "left" ? "flex-start" : align === "center" ? "center" : "right";

  return (
    <Paper
      elevation={3}
      sx={{
        position: "fixed",
        bottom: isStateChanged ? 0 : "-100%",
        width: `calc(100% - ${left})`,
        zIndex: "100",
        transition: "0.8s",
        left,
      }}
    >
      <Box p={2} display="flex" justifyContent={position} gap={2}>
        <Button
          onClick={handleUpdate}
          disabled={isLoading}
          size="large"
          color="secondary"
          variant="contained"
        >
          Update
        </Button>
        <GreyButton
          onClick={onCancel}
          size="large"
          color="secondary"
          variant="contained"
        >
          Cancel
        </GreyButton>
      </Box>
    </Paper>
  );
}

export default BottomBar;
